import AdminStoreDocuments from './AdminStoreDocuments';

export default AdminStoreDocuments;
